<template>
  <div>
    <el-table
        row-key="processIndex"
        :data="tableData"
        border
        stripe
        lazy
        height="350px"
        style="width: 100%"
        :expand-row-keys="expands"
        @expand-change="rowExpand">
      <el-table-column type="expand">
        <template>
          <div style="margin-left: 48px">
            <el-table
                row-key="itemSn"
                :data="productProcessDetailTable"
                border
                stripe
                lazy
                :expand-row-keys="expandsMaterial"
                @expand-change="rowExpandMaterial">
              <el-table-column type="expand">
                <template>
                  <div style="margin-left: 48px">
                    <el-table :data="partsTable" border>
                      <el-table-column label="部件条码" width="180" align="center" prop="partsSn"/>
                      <el-table-column label="部件编号" width="150" align="center" prop="partsNo"/>
                      <el-table-column label="部件名称" min-width="380" align="left" prop="partsName"/>
                      <el-table-column label="扫描人" align="center" prop="operatorName"/>
                      <el-table-column label="扫描时间" width="150" align="center" prop="createTime"/>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="生产条码" align="left" prop="itemSn"/>
              <el-table-column label="报工数量" width="90" align="center" prop="quantity"/>
<!--              <el-table-column label="报工人" width="70" align="center" prop="operatorName"/>-->
              <el-table-column label="报工人" width="70" align="center" prop="scannerName"/>
              <el-table-column label="工序开工时间" width="150" align="center" prop="startTime"/>
              <el-table-column label="工序完工时间" width="150" align="center" prop="finishTime"/>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="派工单号" align="center" prop="billNo" width="140"/>
      <el-table-column label="工单编号" align="center" prop="productionOrderNo" width="160"/>
      <el-table-column label="工序名称" align="center" prop="processName"/>
      <!--      <el-table-column label="物料编号" align="center" prop="materialNo" width="150"/>-->
      <!--      <el-table-column label="物料名称" align="left" prop="materialName" min-width="400"/>-->
      <el-table-column label="派工单数量" align="center" prop="quantity" width="90"/>
      <el-table-column label="报工数量" align="center" prop="scanQuantity" width="70"/>
      <el-table-column align="center" label="最后一次报工时间" prop="lastScanTime" width="150"/>
    </el-table>
  </div>
</template>
<script>
  export default {
    props: {
      pkid: {
        type: Number,
      },
      orderInfo: {
        type: Object,
      },
    },
    watch: {
      pkid: {
        handler(newval) {
          this.pkid = newval;
          this.$nextTick(() => {
            this.getFirstLevelData(this.pkid);
          });
        },
        immediate: true,
      },
    },
    data() {
      return {
        productProcessDetailTable: [],
        tableData: [],
        expands: [], // 只展开一行放入当前行id
        partsTable: [],
        expandsMaterial: [],
      };
    },

    mounted() {
      if (this.orderInfo.pkid) {
        this.getFirstLevelData(this.orderInfo.pkid);
      }
    },

    methods: {
      // 根据生产订单id查询生产过程(第一层数据)
      getFirstLevelData(id) {
        this.$http.get("basic", `productionManage/prodProcess?id=${id}`).then((resp) => {
          if (resp.success) {
            this.tableData = resp.data;
            (this.expands = []), (this.expandsMaterial = []);
            this.productProcessDetailTable = [];
            this.partsTable = [];
          }
        });
      },

      // 展开第一层获取扫描信息
      rowExpand(row, expandedRows) {
        if (expandedRows.length) {
          this.expands = [];
          if (row) {
            this.expands.push(row.processIndex);
            this.$http.get("basic", `productionManage/prodProcessScan?id=${this.orderInfo.pkid}&processIndex=${row.processIndex}`).then((resp) => {
              if (resp.success) {
                this.productProcessDetailTable = resp.data;
                console.log(resp.data);
                // 强制刷新tableData
                this.tableData = this.tableData.slice(0);
              }
            });
          }
        } else {
          this.expands = [];
        }
      },

      // 展开第二层获取部件信息
      rowExpandMaterial(row, expandedRows) {
        if (expandedRows.length) {
          this.expandsMaterial = [];
          if (row) {
            this.expandsMaterial.push(row.itemSn);
            this.$http.get("basic", `productionManage/prodProcessPartsScan?id=${this.orderInfo.pkid}&processIndex=${this.expands[0]}&itemSn=${row.itemSn}`).then((resp) => {
              if (resp.success) {
                this.partsTable = resp.data;
                // 强制刷新tableData
                this.tableData = this.tableData.slice(0);
              }
            });
          }
        } else {
          this.expandsMaterial = [];
        }
      },
    },
  };
</script>
